// extracted by mini-css-extract-plugin
module.exports = {"linksContainer":"style_linksContainer__DwK51","item":"style_item__1oiOA","logo":"style_logo__1gWfo","link":"style_link__3iX7w"};